import React from 'react';
import { getDefaultStr } from '../../modules/crm/inPatient/service/crmUtils';
import ColumnFilterDropdown from '../../modules/reconciliation/reconciliationNew/components/ColumnFilterDropdown';
import { FilterDropdownProps } from 'antd/lib/table/interface';
import FilterDropdownComponent from '../../modules/reconciliation/reconciliationNew/components/FilterDropdownComponent';
import NumberFormatView from '../components/NumberFormatView/NumberFormatView';
import PatientDetail from '../../modules/reconciliation/reconciliationNew/components/cards/PatientDetail';
import ReconciliationDetail from '../../modules/reconciliation/reconciliationNew/components/cards/ReconciliationDetail';
import { TIMLINE_MODAL_TABLE_SUBMITTED_COLOR } from './crmConstants';
import { Tooltip } from 'antd';
import { getDateWithTextMonthForDDMMYYYY, getDateWithTime } from '../../utils/dateTimeUtils';
export const IP_DROPDOWN_SEARCH_INPUT_TYPES = {
  TEXT: 'TEXT',
  AMOUNT: 'AMOUNT',
  DATE_RANGE: 'DATE_RANGE',
  MULTISELECT_CHECKBOX: 'MULTISELECT_CHECKBOX',
  MULTISELECT_DROPDOWN: 'MULTISELECT_DROPDOWN',
};
export const RECONCILIATION_DETAIL_NAV: any[] = [
  {
    tabName: 'Patient Details',
    formComponent: PatientDetail,
  },
  {
    tabName: 'Reconciliation Details',
    formComponent: ReconciliationDetail,
  },
];

export const getColumnSearchDropdown = (extraParams: any): any => ({
  filterDropdown: (props: FilterDropdownProps): any => {
    return (<FilterDropdownComponent {...props} {...extraParams} />);
  },
});

export const RECONCILIATION_STATUS_COLOUR = [
  {
    statusName: 'Not Paid', StatusId: 47, class: 'error-text',
  },
  {
    statusName: 'Short Paid', StatusId: 48, class: 'text-warning',
  },
  {
    statusName: 'Short Paid (Bulk)', StatusId: 49, class: 'text-warning',
  },
  {
    statusName: 'Full Paid', StatusId: 50, class: 'text-success',
  },
  {
    statusName: 'Full Paid (Bulk)', StatusId: 51, class: 'text-success-light',
  },
];

export const getReconciliationTableMapping = (): any => {
  return {
    CLAIM_NO: {
      title: 'Claim No.',
      dataIndex: 'payerClaimNoFinal',
      key: 'payerClaimNoFinal',
      render: (claimNo: any): any => (
        getDefaultStr(claimNo, true)
      ),
      filterIcon: (): any => <ColumnFilterDropdown filterKey="payerClaimNo" />,
      ...getColumnSearchDropdown({
        filterKey: 'payerClaimNo',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search claim No.',
      }),
    },
    INSURER_NAME: {
      title: 'Insurer Name',
      dataIndex: 'insurerName',
      key: 'insurerName',
      render: (insurerName: any): any => (
        getDefaultStr(insurerName, true)
      ),
      sorter: false,
      sortOrder: false,
      filterIcon: (): any => <ColumnFilterDropdown filterKey="insurerName" />,
      ...getColumnSearchDropdown({
        filterKey: 'insurerName',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.MULTISELECT_DROPDOWN,
        placeholder: 'Select insurer name',
        optionPath: '[\'payerList\'][\'allPayers\']',
        optionsFilterKey: 'isInsurer',
        labelKey: 'name',
      }),
    },
    UTR_NO: {
      title: 'UTR No./ Cheque No.',
      dataIndex: 'utrNumber',
      key: 'utrNumber',
      render: (utrNumber: any): any => (
        getDefaultStr(utrNumber, true)
      ),
      filterIcon: (): any => <ColumnFilterDropdown filterKey="utrNumber" />,
      ...getColumnSearchDropdown({
        filterKey: 'utrNumber',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search UTR number',
      }),
    },
    CLAIMED_AMOUNT: {
      title: 'Claimed Amount',
      dataIndex: 'claimedAmount',
      key: 'claimedAmount',
      render: (amount: any): any => (
        <NumberFormatView prefix="₹ " amount={amount} fixedDecimalScale={true} />
      ),
      sorter: false,
      sortOrder: false,
      filterIcon: (): any => <ColumnFilterDropdown filterKey="claimedAmount" />,
      ...getColumnSearchDropdown({
        filterKey: 'claimedAmount',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.AMOUNT,
        placeholder: 'Search claimed amount',
      }),
    },
    CLAIMED_APPROVED_AMOUNT: {
      title: 'Claimed Approved Amount (at DOD)',
      dataIndex: 'approvedAmountDischarge',
      key: 'approvedAmountDischarge',
      render: (amount: any): any => (
        <NumberFormatView prefix="₹ " amount={amount} fixedDecimalScale={true} />
      ),
      sorter: false,
      sortOrder: false,
      filterIcon: (): any => <ColumnFilterDropdown filterKey="approvedAmountDischarge" />,
      ...getColumnSearchDropdown({
        filterKey: 'approvedAmountDischarge',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.AMOUNT,
        placeholder: 'Search approved amount discharge',
      }),
    },
    SETTLED_AMOUNT: {
      title: 'Settled Amount',
      dataIndex: 'settledAmount',
      key: 'settledAmount',
      render: (amount: any): any => (
        <NumberFormatView prefix="₹ " amount={amount} fixedDecimalScale={true} />
      ),
      sorter: false,
      sortOrder: false,
      filterIcon: (): any => <ColumnFilterDropdown filterKey="settledAmount" />,
      ...getColumnSearchDropdown({
        filterKey: 'settledAmount',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.AMOUNT,
        placeholder: 'Search settled amount',
      }),
    },
    DIFFERENCE_AMOUNT: {
      title: 'Difference Amount',
      dataIndex: 'differenceAmount',
      key: 'differenceAmount',
      render: (amount: any): any => (
        <NumberFormatView prefix="₹ " amount={amount} fixedDecimalScale={true} />
      ),
      sorter: false,
      sortOrder: false,
      filterIcon: (): any => <ColumnFilterDropdown filterKey="differenceAmount" />,
      ...getColumnSearchDropdown({
        filterKey: 'differenceAmount',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.AMOUNT,
        placeholder: 'Search difference amount',
      }),
    },
    RECONCILIATION_STATUS: {
      title: 'Reconciliation Status',
      dataIndex: 'reconciliationStatus',
      key: 'reconciliationStatus',
      render: (status: any, data: any): any => {
        let statusClassName = '';
        RECONCILIATION_STATUS_COLOUR.map((colorObject: any): any => {
          if (colorObject.statusName === data?.reconciliationStatus) {
            statusClassName = colorObject.class;
          }
        });
        return (
          <span className={`fsize_sm bold status-text ${statusClassName}`}>{status && status}</span>
        );
      },
      filterIcon: (): any => <ColumnFilterDropdown filterKey="statusId" />,
        ...getColumnSearchDropdown({
          filterKey: 'statusId',
          inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.MULTISELECT_DROPDOWN,
          placeholder: 'Select Status',
          optionPath: '[\'reconciliation\'][\'reconciliationStatusList\']',
        }),
    },
    MEMBER_ID: {
      title: 'Member Id',
      dataIndex: 'memberID',
      key: 'memberID',
      render: (memberID: any): any => (
        getDefaultStr(memberID, true)
      ),
      filterIcon: (): any => <ColumnFilterDropdown filterKey="memberID" />,
      ...getColumnSearchDropdown({
        filterKey: 'memberID',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search member ID',
      }),
    },
    POLICY_NUMBER: {
      title: 'Policy Number',
      dataIndex: 'policyNumber',
      key: 'policyNumber',
      render: (policyNumber: any): any => (
        getDefaultStr(policyNumber, true)
      ),
      filterIcon: (): any => <ColumnFilterDropdown filterKey="policyNumber" />,
      ...getColumnSearchDropdown({
        filterKey: 'policyNumber',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search policy number',
      }),
    },
    FULL_NAME: {
      title: 'Full Name',
      dataIndex: 'patientName',
      key: 'patientName',
      render: (fullName: any): any => (
        getDefaultStr(fullName, true)
      ),
      sorter: false,
      sortOrder: false,
      filterIcon: (): any => <ColumnFilterDropdown filterKey="patientName" />,
      ...getColumnSearchDropdown({
        filterKey: 'patientName',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.TEXT,
        placeholder: 'Search full name',
      }),
    },
    DOA: {
      title: 'DOA',
      dataIndex: 'doa',
      key: 'doa',
      render: (date: any): any => (
        date && getDateWithTextMonthForDDMMYYYY(date)
      ),
      sorter: false,
      sortOrder: false,
      filterIcon: (): any => <ColumnFilterDropdown filterKey="doa" />,
      ...getColumnSearchDropdown({
        filterKey: 'doa',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.DATE_RANGE,
        placeholder: 'Search DOA',
      }),
    },
    DOD: {
      title: 'DOD',
      dataIndex: 'dod',
      key: 'dod',
      render: (date: any): any => (
        date && getDateWithTextMonthForDDMMYYYY(date)
      ),
      sorter: false,
      sortOrder: false,
      filterIcon: (): any => <ColumnFilterDropdown filterKey="dod" />,
      ...getColumnSearchDropdown({
        filterKey: 'dod',
        inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.DATE_RANGE,
        placeholder: 'Search DOD',
      }),
    },
    UTR_DATE: {
      title: 'UTR Date',
      dataIndex: 'utrDate',
      key: 'utrDate',
      render: (date: any): any => (
        date && getDateWithTextMonthForDDMMYYYY(date)
      ),
      sorter: false,
      sortOrder: false,
      // filterIcon: (): any => <ColumnFilterDropdown filterKey="utrDate" />,
      // ...getColumnSearchDropdown({
      //   filterKey: 'utrDate',
      //   inputType: IP_DROPDOWN_SEARCH_INPUT_TYPES.DATE_RANGE,
      //   placeholder: 'Search UTR Date',
      // }),
    },
  };
};

export const TIMELINE_RECONCILIATION_DETAIL_TABLE_COLUMNS_TITLE = [
  {
    title: 'Status',
    dataIndex: 'title',
    key: 'title',
    fixed: 'left' as 'left',
    render: (status: any, data: any): any => {
      let statusClassName = '';
      RECONCILIATION_STATUS_COLOUR.map((colorObject: any): any => {
        if (colorObject.StatusId === data?.statusId) {
          statusClassName = colorObject.class;
        }
      });
      return (
        <span className={`fsize_sm bold status-text ${statusClassName}`}>{status && status}</span>
      );
    },
  },
  {
    title: 'Submitted By',
    dataIndex: 'submittedBy',
    key: 'submittedBy',
    fixed: 'left' as 'left',
    width: '100',
    render: (status: any, data: any): any => {
      let statusClassName = '';
      statusClassName = TIMLINE_MODAL_TABLE_SUBMITTED_COLOR[data.submittedBy];
      return (
        <span className={`fsize_sm bold status-text ${statusClassName}`}>{status && status}</span>
      );
    },
  },
  {
    title: 'UTR No.',
    dataIndex: 'utrNo',
    key: 'utrNo',
  },
  {
    title: 'UTR Settled Date',
    dataIndex: 'utrSettledDate',
    key: 'utrSetteledDate',
    fixed: 'right' as 'right',
    render:   (date: any): any => (
    <Tooltip placement="top" title={`${date && getDateWithTime(date)}`}>
      {date && getDateWithTextMonthForDDMMYYYY(date)}
    </Tooltip>
   ),
  },
  {
    title: 'Approved Amount',
    dataIndex: 'approvedAmount',
    key: 'approvedAmount',
    className: 'column-money ',
    render: (amount: any): any => (
      <NumberFormatView prefix="₹ " amount={amount} fixedDecimalScale={true} />
    ),
  },
  {
    title: 'Settled Amount',
    dataIndex: 'settled',
    key: 'settled',
    className: 'column-money',
    render: (amount: any): any => (
      <NumberFormatView prefix="₹ " amount={amount} fixedDecimalScale={true} />
    ),
  },
  {
    title: 'TDS',
    dataIndex: 'tds',
    key: 'tds',
    className: 'column-money',
    render: (amount: any): any => (
      <NumberFormatView prefix="₹ " amount={amount} fixedDecimalScale={true} />
    ),
  },
  {
    title: 'Reconciliation Comments',
    dataIndex: 'reconciliationComments',
    key: 'reconciliationComments',
  },
];
export const RECONCILIATION_VIEW_OPTIONS = [
  {
    key: 1,
    value: 'Settled Claims',
  },
  {
    key: 2,
    value: 'Open Claims',
  },
  {
    key: 3,
    value: 'UTR View',
  },
];
export const RECONCILIATION_LINKED_CLAIMS_COLUMNS = [
  {
    title: 'Claim No.',
    dataIndex: 'payerClaimNo',
    key: 'payerClaimNo',
    render: (payerClaimNumber: any): any => (
      getDefaultStr(payerClaimNumber, true)
    ),
  },
  {
    title: 'UTR No.',
    dataIndex: 'utrNumber',
    key: 'utrNumber',
    render: (utrNumber: any): any => (
      getDefaultStr(utrNumber, true)
    ),
  },
  {
    title: 'Approved Amount',
    dataIndex: 'claimAppprovedAmount',
    key: 'claimAppprovedAmount',
    render: (amount: any): any => (
      <NumberFormatView prefix="₹ " amount={amount} fixedDecimalScale={true} />
    ),
  },
  {
    title: 'UTR Settled Amount',
    dataIndex: 'utrSetteledAmount',
    key: 'utrSetteledAmount',
    render: (amount: any): any => (
      <NumberFormatView prefix="₹ " amount={amount} fixedDecimalScale={true} />
    ),
  },
  {
    title: 'Reconciliation Status',
    dataIndex: 'reconciliationStatus',
    key: 'reconciliationStatus',
    render: (status: any, data: any): any => {
      let statusClassName = '';
      RECONCILIATION_STATUS_COLOUR.map((colorObject: any): any => {
        if (colorObject.statusName === data?.reconciliationStatus) {
          statusClassName = colorObject.class;
        }
      });
      return (
        <span className={`fsize_sm bold status-text ${statusClassName}`}>{status && status}</span>
      );
    },
  },
];
